module.exports = __webpack_public_path__ + "static/img/1081.751a1cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1081.jpg
// module id = 263
// module chunks = 0